/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents a record of a funnel conversation's status change.
 * This is a TSOA-compatible version (no Zod-inferred types).
 */
export type FunnelStatusHistoryTC = {
    /**
     * Unique identifier of the status history record
     */
    id: number;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Associated funnel conversation identifier
     */
    funnelConversationId: number;
    /**
     * Previous status identifier (nullable)
     */
    fromStatusId?: number | null;
    /**
     * New status identifier (nullable)
     */
    toStatusId?: number | null;
    /**
     * Date when the status was changed
     */
    changedAt: string;
    /**
     * Identifier of the user who changed the status (nullable)
     */
    changedById?: string | null;
    /**
     * Source of the change
     */
    changedBySource: FunnelStatusHistoryTC.changedBySource;
};
export namespace FunnelStatusHistoryTC {
    /**
     * Source of the change
     */
    export enum changedBySource {
        USER = 'USER',
        SYSTEM = 'SYSTEM',
        AI = 'AI',
    }
}

